import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import {getSetting} from '@woocommerce/settings';
import {canMakePayment, LocalPaymentIntentContent} from './local-payment-method';
import {PaymentMethodLabel, PaymentMethod} from "@wc-stripe/blocks-components";

const data = getSetting('stripe_swish_data');

if (data) {
    registerPaymentMethod({
        name: data.name,
        label: <PaymentMethodLabel
            title={data.title}
            paymentMethod={data.name}
            icons={data.icon}/>,
        ariaLabel: 'Swish',
        placeOrderButtonLabel: data.placeOrderButtonLabel,
        canMakePayment: canMakePayment(data.gatewayId),
        content: <PaymentMethod
            content={LocalPaymentIntentContent}
            data={data}/>,
        edit: <PaymentMethod content={LocalPaymentIntentContent} data={data}/>,
        supports: {
            showSavedCards: false,
            showSaveOption: false,
            features: data.features
        }
    })
}
